import React from 'react';

const MobileMenuIcon = () => (
  <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ cursor: 'pointer' }}>
    <path d="M1.00195 1H17.002" stroke="#020963" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1 6H17" stroke="#020963" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1.00195 11H17.002" stroke="#020963" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);
export default MobileMenuIcon;
